import { Spinner } from '../spinner/spinner';
import './screen-loader-style.scss';

interface ScreenLoaderProps {
  loadingMessage?: string;
}

export const ScreenLoader = ({
  loadingMessage = 'Getting things ready...',
}: ScreenLoaderProps) => {
  return (
    <div className="screen-loader">
      <div className="screen-loader-spinner-container">
        <Spinner size="medium" />
        <div className="screen-loader-message">{loadingMessage}</div>
      </div>
    </div>
  );
};
